import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";

function FeedbackAdd() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        ticket_number: '',
        customer_name: '',
        contact_number: '',
        email: '',
        feedback_text: '',
        driver_rating: 5,
        overall_rating: 5
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/feedbacks', formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Feedback added successfully');
            navigate('/accounts/feedback-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error adding feedback');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Add Feedback' />
                <Card>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Ticket Number*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ticket_number"
                                            value={formData.ticket_number}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Customer Name*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="customer_name"
                                            value={formData.customer_name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Contact Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="contact_number"
                                            value={formData.contact_number}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Form.Group>
                                        <Form.Label>Feedback Text*</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            name="feedback_text"
                                            value={formData.feedback_text}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Driver Rating</Form.Label>
                                        <Form.Select
                                            name="driver_rating"
                                            value={formData.driver_rating}
                                            onChange={handleInputChange}
                                        >
                                            {[1,2,3,4,5].map(num => (
                                                <option key={num} value={num}>{num} Stars</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Overall Experience</Form.Label>
                                        <Form.Select
                                            name="overall_rating"
                                            value={formData.overall_rating}
                                            onChange={handleInputChange}
                                        >
                                            {[1,2,3,4,5].map(num => (
                                                <option key={num} value={num}>{num} Stars</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Button type="submit" variant="primary">
                                        Submit Feedback
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default FeedbackAdd;